export const STATUS_META = {
  pending: { bg: "#FBEEDA", color: "#8A5106", label: "Pending" },
  logged: { bg: "#EAF0E7", color: "#3F5B4F", label: "Logged" },
  resolved: { bg: "#D7F0EC", color: "#0F6E56", label: "Resolved" },
  reviewed: { bg: "#E6F5F7", color: "#0E7C8B", label: "Reviewed" },
  signed_off: { bg: "#D7F0EC", color: "#0F6E56", label: "Signed off" },
  flagged: { bg: "#FCEBEB", color: "#A32D2D", label: "Flagged" },
  superseded: { bg: "#F4F1E9", color: "#6B7280", label: "Superseded" },
};

export const statusMeta = (s) => STATUS_META[s] || STATUS_META.pending;

// Auto-flag rules: any Pass/Fail/NA answered "Fail", any option exactly "Critical",
// or a rating-list answer in the TOP TWO tiers of its scale (Sarah & Ryan 2026-09-25).
// Exact value matches on rating lists only — "High winds" (Weather) must never flag.
export const RATING_TOP_TIERS = {
  "Risk Level": ["High", "Critical"],
  "Severity": ["Serious", "Critical"],
  "Priority": ["High", "Urgent"],
};

export const computeFlagReasons = (schema, answers, listsById = {}) => {
  const reasons = [];
  (schema?.sections || []).forEach((sec) =>
    (sec.fields || []).forEach((fl) => {
      const v = answers[fl.id];
      if (fl.type === "pass_fail_na" && v === "fail") reasons.push(`${fl.label}: Fail`);
      const vals = [];
      if (typeof v === "string") vals.push(v);
      if (Array.isArray(v?.picked)) v.picked.forEach((x) => typeof x === "string" && vals.push(x));
      else if (Array.isArray(v)) v.forEach((x) => typeof x === "string" && vals.push(x));
      const tiers = RATING_TOP_TIERS[listsById[fl.list_id]?.name] || [];
      vals.forEach((x) => {
        const t = x.trim();
        if (t.toLowerCase() === "critical") reasons.push(`${fl.label}: Critical`);
        else if (tiers.includes(t)) reasons.push(`${fl.label}: ${t}`);
      });
    })
  );
  return reasons;
};
